import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from 'react-router-dom'
import Class from './Class'
import './App.css'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {
        classes: {}
      }
    }
  }

  componentDidMount() {
    this.loadData()
  }

  getChildContext() {
    return {
      data: this.state.data
    }
  }

  loadData() {
    fetch('http://hosted.anrop.se/zip/aio/sfp.json')
      .then((response) => {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }

        return response.json()
      })
      .then((data) => {
        this.setState({ data })
      })
      .catch((err) => {
        console.log('Fetch Error :-S', err)
      })
  }

  render() {
    return (
      <div className="App">
        <header className="App-header">
          <h1 className="App-title">Arma Docs</h1>
        </header>
        <div>
          <Router>
            <Switch>
              <Route path="/classes/" component={Class}/>
              <Redirect from='/' to='/classes/'/>
            </Switch>
          </Router>
        </div>
      </div>
    )
  }
}

App.childContextTypes = {
  data: PropTypes.object
}

export default App



// WEBPACK FOOTER //
// ./src/App.js